import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import DashboardPage from "../pages/DashboardPage.vue";
import LoginPage from "../pages/Authentication/LoginPage.vue";
import CustomerListPage from "../pages/Customers/CustomerListPage.vue";
import CustomerFormPage from "../pages/Customers/CustomerFormPage.vue";
import ServiceListPage from "../pages/Services/ServiceListPage.vue";
import ServiceFormPage from "../pages/Services/ServiceFormPage.vue";
import PackageListPage from "../pages/Packages/PackageListPage.vue";
import PackageFormPage from "../pages/Packages/PackageFormPage.vue";
import OrderListPage from "../pages/Orders/OrderListPage.vue";
import OrderFormPage from "../pages/Orders/OrderFormPage.vue";
import OrderDetailPage from "../pages/Orders/OrderDetailPage.vue";
import PaymentListPage from "../pages/Payments/PaymentListPage.vue";
import PaymentDetailPage from "../pages/Payments/PaymentDetailPage.vue";
import PaymentChannelListPage from "../pages/PaymentChannels/PaymentChannelListPage.vue";
import PaymentChannelFormPage from "../pages/PaymentChannels/PaymentChannelFormPage.vue";
import UserListPage from "../pages/Users/UserListPage.vue";
import UserFormPage from "../pages/Users/UserFormPage.vue";
import TestimonialListPage from "../pages/Testimonials/TestimonialListPage.vue";
import TestimonialFormPage from "../pages/Testimonials/TestimonialFormPage.vue";
import PartnerListPage from "../pages/Partners/PartnerListPage.vue";
import PartnerFormPage from "../pages/Partners/PartnerFormPage.vue";
import BlogPostListPage from "../pages/BlogPosts/BlogPostListPage.vue";
import BlogPostFormPage from "../pages/BlogPosts/BlogPostFormPage.vue";
import TranslatePriceTierListPage from "../pages/TranslatePriceTiers/TranslatePriceTierListPage.vue";
import TranslatePriceTierFormPage from "../pages/TranslatePriceTiers/TranslatePriceTierFormPage.vue";
import TutorialsPage from "../pages/Tutorials/TutorialsPage.vue";
import TutorialFormPage from "../pages/Tutorials/TutorialFormPage.vue";
import SimilarityProfileListPage from "../pages/SimilarityProfiles/SimilarityProfileListPage.vue";
import SimilarityProfileFormPage from "../pages/SimilarityProfiles/SimilarityProfileFormPage.vue";
import ProtocolSignatoryListPage from "../pages/ProtocolSignatories/ProtocolSignatoryListPage.vue";

const routes: Array<RouteRecordRaw> = [
  { path: "/authentication/login", name: "LoginPage", component: LoginPage, meta: { requiresAuth: false } },
  { path: "/", redirect: "/dashboard" },
  { path: "/dashboard", name: "DashboardPage", component: DashboardPage, meta: { requiresAuth: true } },
  { path: "/customers", name: "CustomerListPage", component: CustomerListPage, meta: { requiresAuth: true } },
  { path: "/customers/create", name: "CustomerCreatePage", component: CustomerFormPage, meta: { requiresAuth: true } },
  { path: "/customers/:id/edit", name: "CustomerEditPage", component: CustomerFormPage, meta: { requiresAuth: true } },
  { path: "/services", name: "ServiceListPage", component: ServiceListPage, meta: { requiresAuth: true } },
  { path: "/services/create", name: "ServiceCreatePage", component: ServiceFormPage, meta: { requiresAuth: true } },
  { path: "/services/:id/edit", name: "ServiceEditPage", component: ServiceFormPage, meta: { requiresAuth: true } },
  { path: "/packages", name: "PackageListPage", component: PackageListPage, meta: { requiresAuth: true } },
  { path: "/packages/create", name: "PackageCreatePage", component: PackageFormPage, meta: { requiresAuth: true } },
  { path: "/packages/:id/edit", name: "PackageEditPage", component: PackageFormPage, meta: { requiresAuth: true } },
  { path: "/similarity-profiles", name: "SimilarityProfileListPage", component: SimilarityProfileListPage, meta: { requiresAuth: true } },
  { path: "/similarity-profiles/create", name: "SimilarityProfileCreatePage", component: SimilarityProfileFormPage, meta: { requiresAuth: true } },
  { path: "/similarity-profiles/:id/edit", name: "SimilarityProfileEditPage", component: SimilarityProfileFormPage, meta: { requiresAuth: true } },
  { path: "/protocol-signatories", name: "ProtocolSignatoryListPage", component: ProtocolSignatoryListPage, meta: { requiresAuth: true } },
  { path: "/orders", name: "OrderListPage", component: OrderListPage, meta: { requiresAuth: true } },
  { path: "/orders/create", name: "OrderCreatePage", component: OrderFormPage, meta: { requiresAuth: true } },
  { path: "/orders/:id", name: "OrderDetailPage", component: OrderDetailPage, meta: { requiresAuth: true } },
  { path: "/orders/:id/edit", name: "OrderEditPage", component: OrderFormPage, meta: { requiresAuth: true } },
  { path: "/payments", name: "PaymentListPage", component: PaymentListPage, meta: { requiresAuth: true } },
  { path: "/payments/:id", name: "PaymentDetailPage", component: PaymentDetailPage, meta: { requiresAuth: true } },
  { path: "/payment-channels", name: "PaymentChannelListPage", component: PaymentChannelListPage, meta: { requiresAuth: true } },
  { path: "/payment-channels/create", name: "PaymentChannelCreatePage", component: PaymentChannelFormPage, meta: { requiresAuth: true } },
  { path: "/payment-channels/:id/edit", name: "PaymentChannelEditPage", component: PaymentChannelFormPage, meta: { requiresAuth: true } },
  { path: "/users", name: "UserListPage", component: UserListPage, meta: { requiresAuth: true } },
  { path: "/users/create", name: "UserCreatePage", component: UserFormPage, meta: { requiresAuth: true } },
  { path: "/users/:id/edit", name: "UserEditPage", component: UserFormPage, meta: { requiresAuth: true } },
  { path: "/testimonials", name: "TestimonialListPage", component: TestimonialListPage, meta: { requiresAuth: true } },
  { path: "/testimonials/create", name: "TestimonialCreatePage", component: TestimonialFormPage, meta: { requiresAuth: true } },
  { path: "/testimonials/:id/edit", name: "TestimonialEditPage", component: TestimonialFormPage, meta: { requiresAuth: true } },
  { path: "/partners", name: "PartnerListPage", component: PartnerListPage, meta: { requiresAuth: true } },
  { path: "/partners/create", name: "PartnerCreatePage", component: PartnerFormPage, meta: { requiresAuth: true } },
  { path: "/partners/:id/edit", name: "PartnerEditPage", component: PartnerFormPage, meta: { requiresAuth: true } },
  { path: "/blog-posts", name: "BlogPostListPage", component: BlogPostListPage, meta: { requiresAuth: true } },
  { path: "/blog-posts/create", name: "BlogPostCreatePage", component: BlogPostFormPage, meta: { requiresAuth: true } },
  { path: "/blog-posts/:id/edit", name: "BlogPostEditPage", component: BlogPostFormPage, meta: { requiresAuth: true } },
  { path: "/translate-price-tiers", name: "TranslatePriceTierListPage", component: TranslatePriceTierListPage, meta: { requiresAuth: true } },
  { path: "/translate-price-tiers/create", name: "TranslatePriceTierCreatePage", component: TranslatePriceTierFormPage, meta: { requiresAuth: true } },
  { path: "/translate-price-tiers/:id/edit", name: "TranslatePriceTierEditPage", component: TranslatePriceTierFormPage, meta: { requiresAuth: true } },
  { path: "/tutorials", name: "TutorialsPage", component: TutorialsPage, meta: { requiresAuth: true } },
  { path: "/tutorials/create", name: "TutorialCreatePage", component: TutorialFormPage, meta: { requiresAuth: true } },
  { path: "/tutorials/:id/edit", name: "TutorialEditPage", component: TutorialFormPage, meta: { requiresAuth: true } },
  { path: "/authentication/logout", name: "LogoutPage", component: { render: () => null } },
  { path: "/:pathMatch(.*)*", redirect: "/dashboard" }
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const token = localStorage.getItem('auth_token');

  if (to.path === '/authentication/logout') {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    next('/authentication/login');
    return;
  }

  if (requiresAuth && !token) {
    next('/authentication/login');
  } else if (to.path === '/authentication/login' && token) {
    next('/dashboard');
  } else {
    // Restrict /users, /testimonials, /partners, /blog-posts, /translate-price-tiers, and /tutorials pages to Super Admins only
    if (to.path.startsWith('/users') || to.path.startsWith('/testimonials') || to.path.startsWith('/partners') || to.path.startsWith('/blog-posts') || to.path.startsWith('/translate-price-tiers') || to.path.startsWith('/tutorials')) {
      const userStr = localStorage.getItem('user');
      let isSuper = false;
      if (userStr) {
        try {
          isSuper = JSON.parse(userStr).role === 'super_admin';
        } catch (e) {
          console.warn("Failed to parse user session info:", e);
        }
      }
      if (!isSuper) {
        next('/dashboard');
        return;
      }
    }
    next();
  }
});

export default router;
